import { useLocation } from '@remix-run/react';
import { useEffect, useRef } from 'react';
import { isBrowser } from '~/utils';

export const IntegrationGoogleTag: React.FC<{
  APP_GTM?: string;
  APP_GA_MEASUREMENT_ID?: string;
}> = ({ APP_GTM, APP_GA_MEASUREMENT_ID }) => {
  const lastLocationKey = useRef<string>('');
  const location = useLocation();

  useEffect(() => {
    if (!isBrowser()) return;
    if (!APP_GA_MEASUREMENT_ID) return;
    if (lastLocationKey.current === location.key) return;

    lastLocationKey.current = location.key;
    window?.gtag?.('config', APP_GA_MEASUREMENT_ID, {
      page_path: location.pathname,
      send_page_view: true,
    });
  }, [APP_GA_MEASUREMENT_ID, location]);

  return (
    <>
      <noscript
        dangerouslySetInnerHTML={{
          __html: `
            <iframe src="https://www.googletagmanager.com/ns.html?id=${APP_GTM}" height="0" width="0" style="display:none;visibility:hidden"></iframe>
          `,
        }}
      ></noscript>
      <script
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.defer=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;
              setTimeout(()=>{f.parentNode.insertBefore(j,f)},0)
              })(window,document,'script','dataLayer','${APP_GTM}');
          `,
        }}
      ></script>
      <script
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('set', 'cookie_flags', 'SameSite=None;Secure');
            gtag('config', '${APP_GTM}');
            gtag('config', '${APP_GA_MEASUREMENT_ID}');
          `,
        }}
      />
    </>
  );
};
